document.addEventListener("DOMContentLoaded", async function () {
  // SLIDERS START
  initializeSliders();
  // SLIDERS END

  // DD START
  await initializeDropdown();
  // DD END
});

// SLIDERS CODE
function initializeSliders() {
  const imageGallerySwiperContainer = document.querySelector(
    ".ft-pp__img-gallery .main-swiper"
  );
  const imageGallerySwiperThumbs = document.querySelector(
    ".ft-pp__img-gallery .thumbs-swiper"
  );
  const currentSliderContainer = document.querySelector(
    ".ft-pp__current-slide"
  );
  const totalSlidesCount = currentSliderContainer.dataset.totalSlidesCount;

  const thumbsSwiper = new Swiper(imageGallerySwiperThumbs, {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    loop: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  const mainSwiper = new Swiper(imageGallerySwiperContainer, {
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
    on: {
      activeIndexChange: function () {
        currentSliderContainer.innerHTML = `${
          this.realIndex + 1
        } / ${totalSlidesCount}`;
        const videos = this.slides.forEach((slide) => {
          const video = slide.querySelector("video");
          if (video) {
            video.pause();
          }
        });
      },
    },
  });

  const thumbsSwiperSlides =
    imageGallerySwiperThumbs.querySelectorAll(".swiper-slide");

  thumbsSwiperSlides.forEach((slide) => {
    slide.addEventListener("click", function () {
      const playButton = this.querySelector(".ft-pp__swiper-video-play-icon");
      if (!playButton) return;
      const blockId = this.dataset.blockId;
      const mainSwiperSlide = imageGallerySwiperContainer.querySelector(
        `.swiper-slide[data-block-id="${blockId}"]`
      );
      if (!mainSwiperSlide) return;
      const mainSliderPlayButton = mainSwiperSlide.querySelector(
        ".ft-pp__swiper-video-play-icon"
      );
      mainSliderPlayButton?.click();
      setTimeout(() => {
        const video = mainSwiperSlide.querySelector("video");
        if (video) {
          video.play();
        }
      }, 200);
    });
  });

  const videoPlayButtons = imageGallerySwiperContainer.querySelectorAll(
    ".ft-pp__swiper-video-play-icon"
  );
  videoPlayButtons.forEach((playButton) => {
    playButton.addEventListener("click", function () {
      const parent = this.parentElement;
      const videoSrc = parent.dataset.videoUrl;
      playButton.style.display = "none";
      const videoElement = document.createElement("video");
      videoElement.src = videoSrc;
      videoElement.controls = true;
      videoElement.autoplay = true;
      videoElement.style.width = "100%";
      videoElement.style.objectFit = "cover";
      parent.appendChild(videoElement);
    });
  });
}

// DROPDOWN CODE
async function initializeDropdown() {
  const CLOSE_SVG = `<svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"/></svg>`;
  const MAX_DD_HEIGHT = 298;

  let isDropdownOpen = false;
  const dropdownSelections = createDropdownSelectionsProxy();
  const {
    ddSelectionContainer,
    ddContainer,
    ddList,
    ddItemsContainer,
    ddButton,
    ddSearchContainer,
    atcButtonContainer,
    atcButton,
    resetButton,
    jsonUrl,
    atcProductUrl,
    shouldOpenInit,
    trimsUrl,
    applicableTrimsElement,
  } = getDropdownElements();

  const marketJson = await fetch(jsonUrl).then((response) => response.json());
  const atcProduct = await fetch(atcProductUrl).then((response) =>
    response.json()
  );
  const trimsJson = await fetch(trimsUrl).then((response) => response.json());

  setupDropdownEventListeners();
  fillMakes();

  if (shouldOpenInit) {
    openDropdown();
  }

  function createDropdownSelectionsProxy() {
    return new Proxy(
      { make: null, model: null, year: null, engine: null, socket: null },
      {
        set(target, property, value) {
          if (value === null) return true;
          if (property === "socket") {
            target[property] = value;
          }
          handleSelectionChange(property, value);
          target[property] = value;
          return true;
        },
      }
    );
  }

  function getDropdownElements() {
    return {
      ddSelectionContainer: document.querySelector(
        ".ft-pp__dropdown-selection-container"
      ),
      ddContainer: document.querySelector(".ft-pp__dropdown-container"),
      ddList: document.querySelector(".ft-pp__dropdown-list"),
      ddItemsContainer: document.querySelector(".ft-pp__dropdown-items"),
      ddButton: document.querySelector(".ft-pp__dropdown-button"),
      ddSearchContainer: document.querySelector(".ft-pp__search-container"),
      atcButtonContainer: document.querySelector(
        ".ft-pp__atc-button-container"
      ),
      atcButton: document.querySelector(".ft-pp__atc-button"),
      resetButton: document.querySelector(".ft-pp__atc-reset-button"),
      jsonUrl: document.querySelector(".ft-pp__dropdown-container").dataset
        .jsonUrl,
      atcProductUrl:
        document.querySelector(".ft-pp__dropdown-container").dataset
          .atcProductUrl + ".js",
      shouldOpenInit:
        document.querySelector(".ft-pp__dropdown-container").dataset
          .shouldOpenOnInit === "true",
      trimsUrl: document.querySelector(".ft-pp__dropdown-container").dataset
        .trimsUrl,
      applicableTrimsElement: document.querySelector(
        ".ft-pp__applicable-trims"
      ),
    };
  }

  function setupDropdownEventListeners() {
    ddButton.addEventListener("click", async function () {
      isDropdownOpen ? await closeDropdown() : await openDropdown();
    });

    resetButton.addEventListener("click", resetDropdown);

    atcButton.addEventListener("click", function () {
      const hideWhileLoadingItems = this.querySelectorAll(
        "[data-role='hide-while-loading']"
      );
      const showWhileLoadingItems = this.querySelectorAll(
        "[data-role='show-while-loading']"
      );

      hideWhileLoadingItems.forEach(
        (item) => (item.style.visibility = "hidden")
      );
      showWhileLoadingItems.forEach((item) => (item.style.display = "block"));

      const cartDrawer = document.querySelector("custom-cart-drawer");
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "style") {
            const isVisible =
              window.getComputedStyle(cartDrawer).visibility === "hidden";
            if (isVisible) {
              hideWhileLoadingItems.forEach(
                (item) => (item.style.visibility = "visible")
              );
              showWhileLoadingItems.forEach(
                (item) => (item.style.display = "none")
              );
              observer.disconnect(); // Stop observing once the visibility is reversed
            }
          }
        });
      });

      observer.observe(cartDrawer, { attributes: true });
    });
  }

  function resetDropdown() {
    Object.keys(dropdownSelections).forEach((key) => {
      dropdownSelections[key] = null;
    });
    ddSelectionContainer.innerHTML = "";
    fillMakes();
    openDropdown();
    setDropdownHeight();
    hideAtcButton();
  }

  function handleSelectionChange(type, value) {
    createSelectionItem(type, value);
  }

  function createSelectionItem(type, value) {
    if (type === "socket") return;
    const div = document.createElement("div");
    div.classList.add("ft-pp__dropdown-selection-item");
    div.dataset.type = type;

    const textSpan = document.createElement("span");
    textSpan.innerText = value;
    textSpan.classList.add("ft-pp__dropdown-selection-text");
    div.appendChild(textSpan);

    const removeButton = document.createElement("span");
    removeButton.classList.add("ft-pp__dropdown-remove-button");
    removeButton.innerHTML = CLOSE_SVG;
    div.appendChild(removeButton);

    ddSelectionContainer.appendChild(div);
    setTimeout(() => div.classList.add("visible"), 10);

    div.addEventListener("click", () => handleSelectionClear(type));
  }

  function handleSelectionClear(type) {
    const resetMap = {
      make: ["make", "model", "body", "engine", "socket"],
      model: ["model", "body", "engine", "socket"],
      body: ["body", "engine", "socket"],
      engine: ["engine", "socket"],
    };

    const resetFunctions = {
      make: fillMakes,
      model: fillModels,
      body: fillYears,
      engine: fillEngines,
    };
    if (type === "make" || type === "model") {
      applicableTrimsElement.innerHTML = "";
    }

    resetMap[type]?.forEach((item) => {
      dropdownSelections[item] = null;
      const itemToRemove = Array.from(
        ddSelectionContainer.querySelectorAll(".ft-pp__dropdown-selection-item")
      ).find((selectionItem) => selectionItem.dataset.type === item);

      if (itemToRemove) removeSelectionItem(itemToRemove);
    });

    resetFunctions[type]?.();
    openDropdown();
    setDropdownHeight();
    hideAtcButton();
  }

  function removeSelectionItem(item) {
    item.classList.remove("visible");
    setTimeout(() => item.remove(), 200);
  }

  async function openDropdown() {
    ddItemsContainer.style.display = "flex";
    await sleep(10);
    setDropdownHeight();
    ddItemsContainer.style.opacity = 1;
    isDropdownOpen = true;
  }

  async function closeDropdown() {
    ddItemsContainer.style.opacity = 0;
    await sleep(210);
    ddItemsContainer.style.display = "none";
    isDropdownOpen = false;
  }

  function fillMakes() {
    const makes = marketJson.map((item) => item.make);
    fillDropdown(makes, "make");
    setupDropdownItemClick("make", fillModels);
  }

  function fillModels() {
    const foundMake = marketJson.find(
      (item) => item.make === dropdownSelections.make
    );
    if (!foundMake) throw new Error("Cannot find make in fillModels function");

    const models = foundMake.models.map((item) => item.model);
    fillDropdown(models, "model");
    setupDropdownItemClick("model", fillYears);
  }

  function fillYears() {
    const foundMake = marketJson.find(
      (item) => item.make === dropdownSelections.make
    );
    const foundModel = foundMake?.models.find(
      (item) => item.model === dropdownSelections.model
    );
    if (!foundModel) throw new Error("Cannot find model in fillYears function");
    const trimsText = trimsJson[foundMake.make]?.[foundModel.model];
    if (trimsText) applicableTrimsElement.innerHTML = trimsText;

    const bodies = foundModel.variants.map((item) => item.body);
    fillDropdown(bodies, "body");
    setupDropdownItemClick("body", fillEngines);
  }

  function fillEngines() {
    const foundMake = marketJson.find(
      (item) => item.make === dropdownSelections.make
    );
    const foundModel = foundMake?.models.find(
      (item) => item.model === dropdownSelections.model
    );
    const foundBody = foundModel?.variants.find(
      (item) => item.body === dropdownSelections.body
    );
    if (!foundBody) throw new Error("Cannot find body in fillEngines function");

    const socket = foundBody.socket;
    const engines = foundBody["engine-volume"]
      .split("-")
      .map((item) => item.trim());
    fillDropdown(engines, "engine");

    const engineItems = ddContainer.querySelectorAll(".ft-pp__dropdown-item");
    engineItems.forEach((item) => {
      item.addEventListener("click", function () {
        const selectedEngine = this.dataset.value;
        dropdownSelections.engine = selectedEngine;
        dropdownSelections.socket = socket;

        const variant = atcProduct.variants.find(
          (item) => item.title === extractSocket(socket)
        );
        if (!variant) throw new Error("Cannot find variant in fillEngines");

        atcButton.dataset.atc = variant.id;
        atcButton.dataset.selection = `${socket} / ${dropdownSelections.make} / ${dropdownSelections.model} / ${dropdownSelections.body} / ${dropdownSelections.engine}`;
        closeDropdown();
        showAtcButton();
      });
    });
  }

  function setupDropdownItemClick(type, nextFillFunction) {
    const items = ddContainer.querySelectorAll(".ft-pp__dropdown-item");
    items.forEach((item) => {
      item.addEventListener("click", function () {
        dropdownSelections[type] = this.dataset.value;
        nextFillFunction();
      });
    });
  }

  function fillDropdown(items, type) {
    ddList.innerHTML = ""; // Clear existing items
    items.forEach((item) => {
      const li = createDropdownItem(item, type);
      ddList.appendChild(li);
    });
    setDropdownHeight();
  }

  function createDropdownItem(item, type) {
    const li = document.createElement("li");
    li.classList.add("ft-pp__dropdown-item");
    li.dataset.value = item;
    li.innerText = item;
    li.dataset.type = type;
    return li;
  }

  function setDropdownHeight() {
    const itemsPaddingTop = parseInt(
      getComputedStyle(ddItemsContainer).paddingTop.replace("px", "")
    );
    const searchBarHeight = parseInt(
      getComputedStyle(ddSearchContainer).height.replace("px", "")
    );
    const listMarginTop = parseInt(
      getComputedStyle(ddList).marginTop.replace("px", "")
    );
    const firstListItem = ddList.querySelector(".ft-pp__dropdown-item");
    const listItemHeight = firstListItem ? firstListItem.offsetHeight : 0;
    const itemsCount = ddList.querySelectorAll(".ft-pp__dropdown-item").length;
    const itemsHeight = itemsCount * listItemHeight;

    const targetHeight =
      itemsHeight + itemsPaddingTop * 2 + searchBarHeight + listMarginTop;

    ddItemsContainer.style.height = `${Math.min(
      targetHeight,
      MAX_DD_HEIGHT
    )}px`;
  }

  function showAtcButton() {
    atcButtonContainer.style.display = "flex";
    ddContainer.style.display = "none";
  }

  function hideAtcButton() {
    atcButtonContainer.style.display = "none";
    ddContainer.style.display = "block";
  }

  function extractSocket(input) {
    const matches = input.replaceAll(" ", "").match(/FT\d+/g);
    return matches ? matches[0] : "";
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
